import React  from "react";
import TrainingModuleTable from "./components/TrainingModuleTable";
import { connect } from "react-redux";


const TrainingModules = () => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">      		
	      	<TrainingModuleTable />
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModules);